import { requiredAssetsToAssetMap } from '@/lib/utils/assetMap';

// @ts-expect-error require.context is not defined in types
const logos = () => requiredAssetsToAssetMap(require.context('@/static/logo/32x32', false, /\.svg$/));

export default logos;
